export const TECHNICZNY_FLAT_AMOUNT = 36000;
export const DOJAZD_FLAT_AMOUNT = 15000;
export const PRACA_FALLBACK_RATE = 40000;

export interface DriverTourismEvent {
	id: string;
	newId: number | null;
	dateFrom: string;
	dateTo: string;
	category: string;
	status: string;
	name: string;
	vehicleLabel: string | null;
}

export interface NawigatorPullStats {
	created: number;
	skipped_duplicate: number;
	skipped_no_driver: Array<{ nawigator_id: number; name: string }>;
	errors: number;
}

export interface NavbridgeBonusesStats {
	created: number;
	updated: number;
	skipped_duplicate: number;
	skipped_no_driver: number;
	skipped_other_driver: number;
	errors: number;
}

export interface DriverWorkRate {
	id: number;
	driver: number;
	dateFrom: string;
	dateTo: string | null;
	workRate: number | string;
	breakRate: number | string | null;
	otherRate: number | string | null;
}

export interface PracaEventRow {
	id: string;
	dateFrom: string;
	dateTo: string;
	daysInMonth: number;
	amount: number;
}

export interface TechnicznyEventRow {
	id: string;
	dateFrom: string;
	dateTo: string;
	amount: number;
}

export interface DojazdEventRow {
	id: string;
	dateFrom: string;
	dateTo: string;
	amount: number;
}

export type GratyfikantSkippedReason = 'no_db' | 'fetch_failed';

export interface GratyfikantSkippedOrganization {
	organization_id: number;
	organization_name: string;
	reason: GratyfikantSkippedReason;
	error?: string;
}

export interface GratyfikantSalariesResponse {
	data: Record<string, unknown>[];
	meta: {
		skipped: GratyfikantSkippedOrganization[];
		fetched_count: number;
	};
}

export interface SalaryCacheResponse {
	id?: number | null;
	gratyfikant_netto?: number | null;
	gratyfikant_currency?: string | null;
	enova_netto?: number | null;
	enova_currency?: string | null;
	settlement_notes?: string | null;
	payment_notes?: string | null;
	settled_at?: string | null;
	settled_by?: string | null;
	override_transfer_pln?: number | null;
	override_cash_pln?: number | null;
	override_cash_eur?: number | null;
}

export interface DriverSettlementBonus {
	id: string;
	ownerId: string;
	name: string;
	settlementBonusNameId: string;
	value: string;
	currency: string | null;
	date: string;
	comment: string | null;
	isSettled: string;
	confirmAt: string | null;
}

export interface SalaryNotesPayload {
	settlement_notes: string;
	payment_notes: string;
}

export interface SalaryOverridesPayload {
	transfer_pln: number | null;
	cash_pln: number | null;
	cash_eur: number | null;
}
